import mime from 'mime';
import { deserializeYesplanAPIDate } from '../libs/dateTimeUtilities';
import { printInShortDateFormat } from '../libs/dateTimePrinting';

export default class YPAttachmentObject {
  constructor(attachmentJSON) {
    this.name = attachmentJSON.originalname;
    this.url = attachmentJSON.dataurl;
    this.date = deserializeYesplanAPIDate(attachmentJSON.date);
    this.userName = attachmentJSON.username;
    this.extension = null;
    if (attachmentJSON.datatype)
      this.extension = mime.getExtension(attachmentJSON.datatype);
    this.comment = attachmentJSON.comment;
  }

  isDocument() {
    return this.name !== undefined && this.extension !== null;
  }

  printName() {
    return this.name;
  }

  printCreationDate(dateFormatSetting) {
    return printInShortDateFormat(this.date, dateFormatSetting);
  }

  printDescription() {
    return this.comment;
  }
}
